<template>
    <div role="main" class="main">
        <div class="container pt-2">
            <div class="row my-2 pb-2">
                <div v-html="homeIntroText"></div>
            </div>
        </div>
        <div class="container pt-2">
            <div class="row my-2 pb-2">
                <div class="col-lg-12">
                    <carousel :responsive="{0:{items:1,nav:false},600:{items:4,nav:false}}" :margin="35" :autoplay="true" :loop="true" :nav="false">

                        <div class="portfolio-item">
                            <span class="thumb-info thumb-info-lighten thumb-info-no-borders thumb-info-bottom-info thumb-info-centered-icons border-radius-0">
                                    <a :href="require('../assets/img/gallery/2016-01.jpg')"  class="lightbox-portfolio" target="_blank">
                                        <img :src="require('../assets/img/gallery/2016-01.jpg')"  class="img-fluid border-radius-0" alt="">
                                    </a>
                            </span>
                        </div>
                        <div class="portfolio-item">
                            <span class="thumb-info thumb-info-lighten thumb-info-no-borders thumb-info-bottom-info thumb-info-centered-icons border-radius-0">
                                    <a :href="require('../assets/img/gallery/2016-02.jpg')"  class="lightbox-portfolio" target="_blank">
                                        <img :src="require('../assets/img/gallery/2016-02.jpg')"  class="img-fluid border-radius-0" alt="">
                                    </a>
                            </span>
                        </div>
                        <div class="portfolio-item">
                            <span class="thumb-info thumb-info-lighten thumb-info-no-borders thumb-info-bottom-info thumb-info-centered-icons border-radius-0">
                                    <a :href="require('../assets/img/gallery/2016-05.jpg')"  class="lightbox-portfolio" target="_blank">
                                        <img :src="require('../assets/img/gallery/2016-05.jpg')"  class="img-fluid border-radius-0" alt="">
                                    </a>
                            </span>
                        </div>
                        <div class="portfolio-item">
                            <span class="thumb-info thumb-info-lighten thumb-info-no-borders thumb-info-bottom-info thumb-info-centered-icons border-radius-0">
                                    <a :href="require('../assets/img/gallery/2016-07.jpg')"  class="lightbox-portfolio" target="_blank">
                                        <img :src="require('../assets/img/gallery/2016-07.jpg')"  class="img-fluid border-radius-0" alt="">
                                    </a>
                            </span>
                        </div>
                        <div class="portfolio-item">
                            <span class="thumb-info thumb-info-lighten thumb-info-no-borders thumb-info-bottom-info thumb-info-centered-icons border-radius-0">
                                    <a :href="require('../assets/img/gallery/2016-08.jpg')"  class="lightbox-portfolio" target="_blank">
                                        <img :src="require('../assets/img/gallery/2016-08.jpg')"  class="img-fluid border-radius-0" alt="">
                                    </a>
                            </span>
                        </div>

                    </carousel>
                </div>
            </div>
        </div>
        <section class="section section-primary border-top-0 mb-0 pt-5 pb-5">
            <div class="container">
                <div class="header-counter">
                    <div class="col-sm-12 mb-5 mb-lg-4">
                            <p>code::dive facts</p>
                        </div>
                    </div>
                <div class="row counters counters-sm counters-text-light">
                    <div class="col-sm-12 col-lg-9 mb-5 mb-lg-0">
                        <div class="row">
                            <div class="col-sm-6 col-lg-3"
                                 :class="index === (facts.length-1) ? '':'mb-5 mb-lg-0'"
                                 v-for="(fact, index) in facts">
                                <div class="counter">
                                    <ICountUp
                                        :delay="delay"
                                        :endVal="fact.number"
                                        :options="options"
                                        @ready="onReady"
                                    />
                                    <label class="text-4 mt-1">{{ fact.text }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-3 text-center">
                        <a href="https://nokiawroclaw.pl/" target="_blank"><img alt="Brought to you by NOKIA" width="170" :src="require('../assets/img/nokia.svg')"></a>
                    </div>
                </div>
            </div>
        </section>
        <Partners />
    </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import Partners from '@/components/Partners.vue'
import carousel from 'vue-owl-carousel'
import ICountUp from 'vue-countup-v2'

export default {
    name: 'Home',
    components: {
        carousel,ICountUp,Partners,
    },
    data(){
        return{
            delay: 1000,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: '',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
            homeIntroHeader: '',
            homeIntroText: '',
            facts: ''
        }
    },
    methods: {
        onReady: function(instance, CountUp) {

        },
        getHomepageConent(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/homepage')
                .then(response => {
                    this.homeIntroText = response.data.data[0].content;

                })

        },
        getFacts(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/facts')
                .then(response => {
                    this.facts = response.data.data;
                })

        },
    },
    created(){
        this.getHomepageConent();
        this.getFacts();
    },
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';
    @import '@/assets/sass/home.scss';
</style>
